import { useEffect, useRef } from 'react';
import Layout from '../Layout/Layout';
import { Button, Row, Col, Container } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';

const ErrorGeneric = ({ resetErrorBoundary }) => {
  const location = useLocation();
  const errorLocation = useRef(location.pathname);
  const client = useApolloClient();

  useEffect(() => {
    if (location.pathname !== errorLocation.current) {
      handleErrorBoundary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, resetErrorBoundary]);

  const {
    images: { genericErrorImg },
  } = useAppContext();

  const { t } = useTranslator();
  const handleErrorBoundary = () => {
    localStorage.removeItem('apollo-cache-persist');
    client.clearStore();
    resetErrorBoundary();
  };

  return (
    <Layout>
      <div className="page-template-error">
        <section className="text-center d-flex align-items-center full-height">
          <Container>
            <Row>
              <Col md={{ size: 4, offset: 4 }}>
                <img
                  src={genericErrorImg}
                  className="img-fluid mb-xl"
                  width="343"
                  height="250"
                  alt=""
                />
                <h2 className="title-medium semi-bold">{t('universalError.title')}</h2>
                <p className="mb-xl text-text-variant-color">{t('universalError.content')}</p>
                <Button color="primary" className="w-100" onClick={handleErrorBoundary}>
                  {t('universalError.tryAgain.button')}
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

export default ErrorGeneric;
